import React from 'react';
import PropTypes from 'prop-types';
import './detail.css';

/** Vertical timeline. `items` = [{ id, title, meta, icon, tone }]. */
const Timeline = ({ items }) => (
  <ol className='dt-timeline'>
    {items.map((item, index) => (
      <li className='dt-timeline__item' key={item.id ?? index}>
        <span
          className={`dt-timeline__dot${item.tone ? ` dt-timeline__dot--${item.tone}` : ''}`}
          aria-hidden='true'
        >
          <i className={item.icon || 'ri-checkbox-circle-line'} />
        </span>
        <div className='dt-timeline__content'>
          <span className='dt-timeline__title'>{item.title}</span>
          {item.meta && <span className='dt-timeline__meta'>{item.meta}</span>}
        </div>
      </li>
    ))}
  </ol>
);

Timeline.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.node.isRequired,
      meta: PropTypes.node,
      icon: PropTypes.string,
      tone: PropTypes.oneOf(['success', 'warning', 'danger', 'muted']),
    })
  ).isRequired,
};

export default Timeline;
